import { Create, Form, Image, Input, Select, Table, TextField, Upload, UploadFile, UploadProps, useForm, useSelect, useTable } from '@pankod/refine-antd';
import { IResourceComponentsProps } from '@pankod/refine-core';
import { useMemo, useState } from 'react';
import 'react-mde/lib/styles/css/react-mde-all.css';
import { ILabel } from 'types/label.interface';
import { IRelease } from 'types/releaase.interface';
import { ITrack, ITrackResponse } from 'types/track.interface';
import { beforeUpload } from 'utils';

export const ReleaseCreate: React.FC<IResourceComponentsProps> = () => {
    const [fileListArtwork, setFileListArtwork] = useState<UploadFile[]>();
    const [label, setLabels] = useState<string>('62d9167be4eba68aaedc5abd');
    const [trackSelect, setTrackSelect] = useState<string[]>([]);

    const handleChangeLabel = (value: any) => {
        setLabels(value);
    };

    const { formProps, saveButtonProps, formLoading } = useForm<IRelease>();

    const handleChangeArtwork: UploadProps['onChange'] = ({ fileList: newFileList }) => setFileListArtwork(newFileList);

    const { selectProps: TrackSelectProps } = useSelect<ITrack>({
        resource: `tracks/search/${label}`,
        fetchSize: 100,
        optionLabel: 'title',
        optionValue: '_id',
    });


    const { selectProps: releasePricing } = useSelect<any>({
        resource: `release-pricing/label/${label}`,
        fetchSize: 10000,
        optionLabel: 'name',
        optionValue: '_id',
    });

    const { selectProps: LabelSelectProps } = useSelect<ILabel>({
        resource: 'labels',
        fetchSize: 100,
        optionLabel: 'name',
        optionValue: '_id',
    });

    console.log(LabelSelectProps, 'LabelSelectProps');

    const { tableProps, searchFormProps } = useTable<ITrackResponse>({
        resource: `tracks/search/${label}`,
        initialPageSize: 100,
    });

    const trackInRelease = useMemo(() => {
        let trackTable = (tableProps?.dataSource || []).filter((track: any) => trackSelect.includes(track._id));
        return {
            dataSource: trackTable,
        };
    }, [trackSelect, tableProps]);

    return (
        <Create saveButtonProps={saveButtonProps} isLoading={formLoading}>
            <Form {...formProps} layout='vertical'>
                <Form.Item
                    label='Title'
                    name='title'
                    rules={[
                        {
                            required: true,
                            message: 'Title is required',
                        },
                    ]}
                    style={{ width: '100%' }}
                >
                    <Input placeholder='Enter Multipack title' />
                </Form.Item>
                <Form.Item
                    label='Description'
                    name='description'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                    style={{ width: '100%' }}
                >
                    <Input placeholder='Enter Multipack Description' />
                </Form.Item>

                <Form.Item
                    label='Multipack Cover Image'
                    name='artwork'
                    rules={[
                        {
                            required: false,
                        },
                    ]}
                    style={{ marginBottom: '30px', width: '30%' }}
                >
                    <Upload
                        accept='image/*'
                        name='artwork'
                        listType='picture-card'
                        fileList={fileListArtwork}
                        beforeUpload={beforeUpload}
                        onChange={handleChangeArtwork}
                        maxCount={1}
                    >
                        change
                    </Upload>
                </Form.Item>

                <Form.Item
                    label='Label'
                    name='label'
                    rules={[
                        {
                            required: true,
                            message: 'Label is required',
                        },
                    ]}
                >
                    <Select {...LabelSelectProps} onChange={handleChangeLabel} />
                </Form.Item>
                <Form.Item
                    label='Multipack Pricing'
                    name='releaseOptionId'
                    rules={[
                        {
                            required: true,
                            message: 'Multipack Pricing is required',
                        },
                    ]}
                >
                    <Select {...releasePricing}  />
                </Form.Item>
                <Form.Item
                    label='Price'
                    name='price'
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Input placeholder='Enter price Multipack' />
                </Form.Item>
                <Form.Item
                    label='Tracks'
                    name='tracks'
                    rules={[
                        {
                            type: 'array',
                            min: 2,
                        },
                        {
                            required: true,
                            message: 'Tracks is required',
                        },
                    ]}
                >
                    <Select
                        mode='multiple'
                        {...TrackSelectProps}
                        onChange={(value: any) => {
                            searchFormProps?.form?.setFields(value);
                            searchFormProps?.form?.submit();
                            setTrackSelect(value);
                        }}
                    />
                </Form.Item>
                <Table {...trackInRelease} rowKey='_id' style={{overflow: 'scroll'}}>
                    <Table.Column dataIndex='artwork' key='artwork' title='Artwork' render={(value, item, index) => <Image width={50} src={value} />} />
                    <Table.Column dataIndex='title' key='title' title='Title' render={(value) => <TextField value={value} />} />
                    <Table.Column dataIndex='artist' key='artist' title='Artist' render={(value) => <TextField value={value} />} />
                    <Table.Column dataIndex='previewUrl' key='previewUrl' title='Preview' render={(value) => <audio controls src={value} />} />
                    <Table.Column dataIndex='price' key='price' title='Price' render={(value) => <TextField value={value} />} />
                </Table>
            </Form>
        </Create>
    );
};
